import { render, staticRenderFns } from "./jdDeclare.vue?vue&type=template&id=f1158b86&scoped=true&"
import script from "./jdDeclare.vue?vue&type=script&lang=js&"
export * from "./jdDeclare.vue?vue&type=script&lang=js&"
import style0 from "./jdDeclare.vue?vue&type=style&index=0&id=f1158b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1158b86",
  null
  
)

export default component.exports